<template>
    <!-- Layout inner -->
    <div class="layout-inner pg_content course_about program requirements">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">
          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>
          <template v-if="showPage">

            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 tabs_lyt_v22">


              <!--
              <div class="row result_row">

            		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 thumbnail_container">
                  <div class="thumbnail_container_inner">
                    <img class="thumb_img" v-if="programGuide.thumbnailURL" :src="programGuide.thumbnailURL" tabindex="0">
            			  <div v-else class="default_thumb">
                      <span class="ic ic-degreeProgram"></span>
                    </div>
                  </div>
            		</div>

                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 entity_details">

              		<div v-if="showMedianIncome" class="row" :aria-label="'median income ' + currencyLabel + programGuide.medianIncomePerYear" tabindex="0">
                			<div class="label">{{medianIncomeLabel}}</div>
                			<div class="val" v-if="programGuide.medianIncomePerYear">
                				{{currencyLabel}} <span v-html="addCommaInNumber(programGuide.medianIncomePerYear)"></span>
                			</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

              		<div v-if="showJobPostings" class="row" :aria-label="'job postings ' + programGuide.totalJobPostings" tabindex="0">
                			<div class="label">{{jobPostingsLabel}}</div>
                			<div class="val" v-if="programGuide.totalJobPostings">
                				<span v-html="addCommaInNumber(programGuide.totalJobPostings)"></span>
                			</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

              		<div v-if="showGrowthRate" class="row" :aria-label="'growth rate ' + programGuide.growthRate" tabindex="0">
                			<div class="label">{{growthRateLabel}}</div>
                			<div class="val" v-if="programGuide.growthRate">{{programGuide.growthRate}}%</div>
                			<div class="val no_data" v-else>N/A</div>
              		</div>

                </div>

              </div>
              -->

              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="tabs_container">
                    <b-tabs>
                      <b-tab :title="getCoursesLabel()" active @click="showTab('COURSES')" v-if="programGuide.categories.length > 0">
                        <template v-if="showCourses">
                          <program-courses ref="programCourses" :pathway-id="programGuide.uuid"></program-courses>
                        </template>
                      </b-tab>
                      <b-tab :title="getPrerequisiteLabel()" @click="showTab('PREREQUISITE')" v-if="educationReqs.length > 0">
                        <template v-if="showPrerequisite">
                          <program-education ref="programEducation" :pathway-id="programGuide.uuid"></program-education>
                        </template>
                      </b-tab>
                      <b-tab :title="getCocurricularLabel()" @click="showTab('COCURRICULAR')" v-if="cocurricularReqs.length > 0">
                        <template v-if="showCoCurricular">
                          <program-cocurricular ref="programCocurricular" :pathway-id="programGuide.uuid"></program-cocurricular>
                        </template>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>

            </div>
            <!-- / Page content -->

            <program-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>

          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramCourses from './ProgramCourses'
import ProgramEducation from './ProgramEducation'
import ProgramCocurricular from './ProgramCocurricular'

export default {
  name: 'programGuideRequirements',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramCourses,
    ProgramEducation,
    ProgramCocurricular,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      programGuide: {},
      showPage: false,
      showLoader: true,
      showCourses: true,
      showCoCurricular: false,
      showPrerequisite: false,
      educationReqs: [],
      cocurricularReqs: []
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadProgramEducation',
      'loadProgramCocurricular',
      'loadInstitutionPackage'
    ]),
    showTab (tab) {
      this.showCourses = false
      this.showCoCurricular = false
      this.showPrerequisite = false
      if (tab && tab === 'PREREQUISITE') {
        this.showPrerequisite = true
      } else if (tab && tab === 'COCURRICULAR') {
        this.showCoCurricular = true
      } else {
        this.showCourses = true
      }
    },
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      let pathwayId = this.programGuide.uuid
      this.educationReqs = await this.loadProgramEducation(pathwayId)
      this.cocurricularReqs = await this.loadProgramCocurricular(pathwayId)
      this.showLoader = false
      this.showPage = true
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getCocurricularLabel () {
      if(this.programGuide.cocurricularRequirement && this.programGuide.cocurricularRequirement.length>0 && this.programGuide.cocurricularRequirement[0].tabLabel) {
        return this.programGuide.cocurricularRequirement[0].tabLabel
      }
      return 'Co-Curricular'
    },
    getPrerequisiteLabel () {
      if(this.programGuide.educationRequirement && this.programGuide.educationRequirement.length>0 && this.programGuide.educationRequirement[0].tabLabel) {
        return this.programGuide.educationRequirement[0].tabLabel
      }
      return 'Prerequisite'
    },
    getCoursesLabel () {
      if(this.programGuide.categories && this.programGuide.categories.length>0 && this.programGuide.categories[0].tabLabel) {
        return this.programGuide.categories[0].tabLabel
      }
      return 'Courses'
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },
    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },
    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },
    currencyLabel () {
      return '$'
    },
    isComingFromLearnerDashboard () {
      return (this.$route.query && (this.$route.query.returnTo === 'learnerDashboard'))
    },
    returnTo () {
      return this.isComingFromLearnerDashboard ? 'learnerDashboard' : 'programGuideMenu'
    },
    exploreProgramsLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
       if (exploreFeature) {
         for (var i = 0; i < exploreFeature.flags.length; i++) {
           if (exploreFeature.flags[i].title === 'useProgramLongText') {
             if (exploreFeature.flags[i].isEnabled) {
               return exploreFeature.flags[i].label
             }
           }
         }
       }
       return 'program'
    },
    exploreProgramsLabelPlural () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
       if (exploreFeature) {
         for (var i = 0; i < exploreFeature.flags.length; i++) {
           if (exploreFeature.flags[i].title === 'useProgramLongText') {
             if (exploreFeature.flags[i].isEnabled) {
               return exploreFeature.flags[i].label + 's'
             }
           }
         }
       }
       return 'programs'
    },
    pageTitle () {
      return this.isComingFromLearnerDashboard ? 'Learner Dahsboard' : this.exploreProgramsLabel + ' Details'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideRequirements.vue